// extracted by mini-css-extract-plugin
module.exports = {"siderCollapsedWidth":"40px","container":"container--3ZqUg","videoSlideTitle":"videoSlideTitle--3pAXs","currentChat":"currentChat--2-dEz","message":"message--uL7Td"};